"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvatarInitial = getAvatarInitial;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

/**
 * Get the first character of a username for use as a default avatar initial.
 *
 * Uses spread operator to iterate by Unicode code points instead of charAt(0) which
 * returns the first UTF-16 code unit. For characters above U+FFFF (e.g. mathematical
 * symbols, emojis), charAt(0) returns a lone surrogate half (\uD835) which is invalid
 * UTF-8 and breaks SSR HTML serialization, causing the entire SSR page to break and double-render.
 */
function getAvatarInitial(username) {
  return ((0, _toConsumableArray2.default)(username || '')[0] || '').toUpperCase();
}